import { render, staticRenderFns } from "./dspProductSelect.vue?vue&type=template&id=c1215946&"
import script from "./dspProductSelect.vue?vue&type=script&lang=js&"
export * from "./dspProductSelect.vue?vue&type=script&lang=js&"
import style0 from "./dspProductSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports